import { render, staticRenderFns } from "./XunjiaChujia.vue?vue&type=template&id=b25a050a"
import script from "./XunjiaChujia.vue?vue&type=script&lang=js"
export * from "./XunjiaChujia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports